export default __webpack_public_path__ + "static/media/na.e4440f5a.svg";